module.exports = __webpack_public_path__ + "static/media/Wi-Fi.7cd4e7dc.jpg";